import { render, staticRenderFns } from "./FactoryHistoricalData.vue?vue&type=template&id=604a3164&scoped=true"
import script from "./FactoryHistoricalData.vue?vue&type=script&lang=js"
export * from "./FactoryHistoricalData.vue?vue&type=script&lang=js"
import style0 from "./FactoryHistoricalData.vue?vue&type=style&index=0&id=604a3164&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604a3164",
  null
  
)

export default component.exports